/*
 * @Description: 
 * @Author: HuangYinYin
 * @Date: 2025-01-16 16:23:40
 * @FilePath: \dataview-next\src\custom-component\viewerGIS\Behaviors\SubmergenceBehaviors.js
 * @LastEditTime: 2025-01-17 18:19:05
 * @LastEditors: HuangYinYin
 */
import IBehaviors from './IBehaviors';

export default class SubmergenceBehaviors extends IBehaviors {
    constructor(viewer, comp) {
        super(viewer, comp);
        this.viewer = viewer;
        this.comp = comp;

        this.init();
    }

    init() {
        const list = this.getBehaviors();

        this.registerBehaviors(list);
    }

    getBehaviors() {
        const viewer = this.viewer;

        return [
            {
                label: '[淹没分析]显示淹没区域',
                desc: `
                    参数[ data ] => 淹没区域数据
                    参数[ height ] => 淹没区域当前水位高度
                    参数[ isShow ] => 是否显示淹没区域
                    参数[ isLocation ] => 是否定位淹没区域
                    参数[ remove ] => 是否清除之前的淹没区域
                    `,
                value: 'submergence_showSubmergenceKml',
                func: (params) => {
                    if (!viewer) return this.comp.$message.error('操作失败，viewer未初始化');

                    let data = params?.data || [];
                    let isShow = JSON.parse(params.isShow);
                    let isLocation = JSON.parse(params.isLocation);
                    let remove = JSON.parse(params.remove || 'false');

                    if (remove) {
                        viewer.Plot.removeKmlByKeyWords('submergence');
                        viewer.Marker.removeMarkerByKeyWords('submergenceMarker');
                    }

                    if (data?.length === 0) return;

                    let kml = data[0]?.path;
                    if (viewer.Plot.kmlCollection['submergence' + data[0].id]) {
                        viewer.Plot.showKml('submergence' + data[0].id, isShow);
                        viewer.Marker.showMarker('submergenceMarker' + data[0].id, isShow);

                        if (isShow && isLocation) viewer.Plot.locationKml('submergence' + data[0].id);
                    } else {
                        if (!isShow) return;

                        viewer.Plot.createKmlByServe('submergence' + data[0].id, {
                            kmlFile: {
                                path: kml,
                                isModels: false
                            }
                        }).then(({ dataSource }) => {
                            let positions = viewer.Plot.getKmlPositions(dataSource);
                            if (positions?.length === 0) return;

                            let center = viewer.Turf.getMultiPointCenter(positions[0]);
                            viewer.Marker.createMarker('submergenceMarker' + data[0].id, {
                                type: 'Billboard_And_Label',
                                position: {
                                    lng: center.lng,
                                    lat: center.lat,
                                    height: Number(params.height)
                                },
                                options: {
                                    billboard: {
                                        image: 'https://models.bimcc.net/gisFiles/images/infoBg/currentWater.png',
                                        width: 200,
                                        height: 49,
                                        heightReference: 2,
                                        horizontalOrigin: 1
                                    },
                                    label: {
                                        text: '当前水位：' + Number(params.height) + 'm',
                                        font: 'normal 16px MicroSoft YaHei',
                                        pixelOffset: [47, -17],
                                        outlineColor: '#ffffff',
                                        showBackground: true,
                                        backgroundColor: 'rgba(18,54,74,1)',
                                        heightReference: 2,
                                        horizontalOrigin: 1
                                    }
                                }
                            });

                            if (isLocation) viewer.Plot.locationKml('submergence' + data[0].id);
                        });
                    }
                }
            },
            {
                label: '[淹没分析]清除所有淹没区域',
                desc: `
                    参数[ 无 ]
                    `,
                value: 'submergence_removeAllSubmergenceKml',
                func: () => {
                    if (!viewer) return this.comp.$message.error('操作失败，viewer未初始化');

                    viewer.Plot.removeKmlByKeyWords('submergence');
                    viewer.Marker.removeMarkerByKeyWords('submergenceMarker');
                }
            },
            {
                label: '[淹没分析]创建淹没分析(真实水面)',
                desc: `
                    参数[data] => 通用数据对象，包含起始水位，终止水位等信息
                    参数[fillColor] => 可选，水面颜色
                    参数[fillAlpha] => 可选，水面不透明度
                    参数[submergenceType] => 可选，淹没分析类型，选择time或者speed
                    参数[time] => 可选，按照总时间模拟淹没过程，单位为秒
                    参数[speed] => 可选，按照淹没速度模拟淹没过程，单位为米/秒
                    参数[isLocation] => 可选，是否定位到淹没区域
                    参数[isLabel] => 可选，是否显示水位标签
                    参数[remove] => 可选，是否清除之前的淹没分析对象
                    `,
                value: 'submergence_createSubmergenceReal',
                func: (params) => {
                    if (!this.viewer) return this.comp.$message.error('操作失败，viewer未初始化');
                    const viewer = this.viewer;

                    console.log('淹没分析', params);

                    let data = params?.data?.data;
                    if (data?.length === 0) return;

                    let item = data[0];
                    if (!item?.kml_range?.path) return;

                    let heights = [];
                    let {
                        fillColor = '#006ab4',
                        fillAlpha = 80,
                        submergenceType = 'time',
                        time = 20,
                        speed = 2,
                        isOutRange = 'false',
                        isLocation = 'true',
                        isLabel = 'true',
                        remove = 'true'
                    } = params;

                    if (JSON.parse(remove)) viewer.Analysis.removeAll();

                    viewer.Plot.unloadKmlByServe({
                        kmlFile: {
                            path: item.kml_range.path,
                            isModels: false
                        }
                    }).then(({ dataSource }) => {
                        let positions = viewer.Plot.getKmlPositions(dataSource);
                        if (positions.length === 0) return;

                        viewer.Scene.setSceneConfig({
                            optimize: {
                                isRequestRender: false
                            }
                        });
                        viewer.Analysis.createSubmergenceReal(undefined, {
                            positions: positions[0],
                            heights, 
                            fillColor, 
                            fillAlpha,
                            submergenceType,  
                            time, 
                            speed, 
                            isOutRange: JSON.parse(isOutRange), 
                            isLocation: JSON.parse(isLocation),
                            isLabel: JSON.parse(isLabel)
                        });
                    });
                }
            },
            {
                label: '[淹没分析]删除全部淹没分析对象',
                desc: `
                    参数[ 无 ]。 
                    `,
                value: 'submergence_removeAll',
                func: () => {
                    if (!this.viewer) return this.comp.$message.error('操作失败，viewer未初始化');

                    this.viewer.Analysis.removeAll();
                    this.viewer.Scene.setSceneConfig({
                        optimize: {
                            isRequestRender: true
                        }
                    });
                }
            },
            {
                label: '[淹没分析]删除指定淹没分析对象',
                desc: `
                    参数[ key ] => 淹没分析对象唯一标识值key
                    `,
                value: 'submergence_remove',
                func: (params) => {
                    if (!this.viewer) return this.comp.$message.error('操作失败，viewer未初始化');

                    this.viewer.Analysis.remove(params.key);
                }
            },
            {
                label: '[淹没分析]删除关键字淹没分析对象',
                desc: `
                    参数[ keyWords ] => 淹没分析对象唯一标识值key中包含的关键字
                    `,
                value: 'submergence_removeByKeyWords',
                func: (params) => {
                    if (!this.viewer) return this.comp.$message.error('操作失败，viewer未初始化');

                    this.viewer.Analysis.removeByKeyWords(params.keyWords);
                }
            },
        ];
    }
}